import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GCategoriaService } from 'src/app/core/service/gcategoria.service';
import { PaginaService } from 'src/app/core/service/pagina.service';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss']
})
export class SiteComponent implements OnInit,AfterViewInit {

menus:any;
menusFinal:any = [];
paginas:any;
transparencias:any;
auditorias:any;
planificaciones:any;
manuales:any
tramites:any;
servicios:any;
programas:any;
proyectos:any;
gaceta: any;

  constructor(
    public paginaService:PaginaService,
    public gCategoriaService: GCategoriaService,
    private route: ActivatedRoute, 
    private router: Router
  ) { }

  ngAfterViewInit(): void {
    // this.listarMenuAux();
  }

  ngOnInit(): void {

    this.listarMenu();
    // this.listarPaginas("Institucion");
    // this.listarTransparencia("Transparencia");
    // this.listarAuditorias("Auditoria");
    // this.listarPlanificaciones("PLANIFICACIÓN E INFORMACIÓN FINANCIERA");
    // this.listarManuales("Reglamentos y manuales");
    // this.listarTramites("Tramites");
    // this.listarServicios("Servicios");
    // this.listarProgramas("Programas");
    // this.listarProyectos("Proyectos");
    // this.listarGacetaMunicipal('Gaceta Municipal');

  }

  listarMenu(){
    this.gCategoriaService.getMenuList().subscribe(
      data => {
        // this.menus = data;
        // this.menusFinal = data;
        // for (let index = 0; index < this.menus.length; index++) {
        //   if ( this.menus[index].flag === true) {
        //     this.menusFinal[index]. =
        //   }
        // }

        // // this.menus.map((objeto: any) => {
        // //   this.menusFinal.push(objeto.nombre);
        // // })
        // console.log(this.menusFinal);

        this.menus = data;

        // Crear un nuevo arreglo con categorías y subcategorías agrupadas
        this.menusFinal = this.menus.map(categoria => {
          const subCategorias = categoria.flag === 0 ? categoria.sub_categorias[0].paginas : categoria.sub_categorias;


          // const subCategorias = categoria.flag === 0
          //   ? categoria.sub_categorias.map(subCategoria => ({
          //       ...subCategoria,
          //       dir: subCategoria.paginas.map(pagina => pagina.pagina_id)
          //     }))
          //   : categoria.sub_categorias;

          if (categoria.dir === 'institucional') {
            subCategorias.push({
              "pagina_id": 2,
              "nombre": "EJECUTIVO MUNICIPAL",
              "descripcion": "EJECUTIVO MUNICIPAL",
              "habilitado": 1,
              "es_menu": 0,
              "user_id": 1,
              "sub_categoria_id": 6,
              "tipo": 1,
              "estatico": 1,
            })
            subCategorias.push({
              "pagina_id": 2,
              "nombre": "CONCEJO MUNICIPAL",
              "descripcion": "CONCEJO MUNICIPAL",
              "habilitado": 1,
              "es_menu": 0,
              "user_id": 1,
              "sub_categoria_id": 6,
              "tipo": 2,
              "estatico": 1,
            })
          }
          
          return {
            categoria: categoria,
            subCategorias: subCategorias
          };
        });

        console.log(this.menusFinal);
        },
      error => {
        console.log('error',error.error);
      }
    );
  }

  listarPaginas(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(1).subscribe(
      data => {
        this.paginas = data;
        console.log(this.paginas);
      },
      error => {
        console.log('error',error.error);
      }
    );
  }

  listarTransparencia(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(3).subscribe(
      data => {
        this.transparencias = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarAuditorias(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(15).subscribe(
      data => {
        this.auditorias = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarPlanificaciones(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(13).subscribe(
      data => {
        this.planificaciones = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }

  listarGacetaMunicipal(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(18).subscribe(
      data => {
        this.gaceta = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }


  listarManuales(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(14).subscribe(
      data => {
        this.manuales = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarTramites(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(12).subscribe(
      data => {
        this.tramites = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarServicios(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(2).subscribe(
      data => {
        this.servicios = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarProgramas(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(16).subscribe(
      data => {
        this.programas = data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarProyectos(nombre:string){
    this.paginaService.getListarPaginasMenuHabilitados(17).subscribe(
      data => {
        this.proyectos= data;
      },
      error => {
        console.log('error',error.error);
      }
    );
  }
  listarMenuAux(){
    console.log('dnaiel');
    if($('.mobile-nav-wrapper').length) {
      $('.mobile-nav-toggler').on('click',function() {
        $('.mobile-nav-wrapper').toggleClass('expanded')
        $('body').toggleClass('locked')
      })
      var menu_content = $('.main-menu .navigation ul')[0].outerHTML
      $('.mobile-nav-container').html(menu_content)
      $('.mobile-nav-container .main-menu-list li.has-dropdown > a').append('<button><i class="fa-solid fa-chevron-right"></i></button>')
      $('.mobile-nav-container .main-menu-list li.has-dropdown > a button').on('click',function() {
        $(this).toggleClass('expanded')
        $(this).parents('a').siblings('ul').slideToggle()
      })
    }
  }

  reloadComponent() {
    const currentRoute = this.route.snapshot;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentRoute.queryParams,
      queryParamsHandling: 'merge'
    });
  }
}
